<template>
  <div class="result-header">
    <div class="result-header-container container">
      <div class="result-header__cell">
        <h1 class="result-header-main-title">O Valor Social do seu imposto</h1>
        <h2 class="result-header-main-subtitle">O que você paga permite financiar <span>por ano</span>, direta ou indiretamente, um dos benefícios abaixo:</h2>
      </div>

      <div class="result-header__cell result-header__cell--expand">
        <img class="result-header-highlight" src="@/assets/images/result/hero-calculadora.jpg" />
        <span class="result-header-credit">Crédito: Paulo Pereira/Oxfam Brasil</span>
      </div>

      <div class="result-header__cell">
        <strong class="result-header-title">{{animateTotalStudents}}</strong>
        <p>estudantes da educação fundamental</p>
      </div>

      <div class="result-header__cell">
        <strong class="result-header-title">{{animateTotalHealth}}</strong>
        <p>pessoas atendidas na saúde pública</p>
      </div>

      <div class="result-header__cell">
        <strong class="result-header-title">{{animateTotalPavimentation}}</strong>
        <p>metros quadrados de vias pavimentadas</p>
      </div>

      <div class="result-header__cell">
        <strong class="result-header-title">{{animateTotalTrash}}</strong>
        <p>quilos de lixo coletados</p>
      </div>

      <div class="result-header__cell">
        <strong class="result-header-title">{{animateTotalLightning}}</strong>
        <p>pontos de iluminação pública</p>
      </div>

      <div class="result-header__cell result-header__cell--tip">
        <svg class="result-header--icon-lamp">
          <use xlink:href="#icon-lamp" />
        </svg>
        <strong class="result-header-subtitle">Você sabia?</strong>
        <p>Todo mundo paga impostos, mesmo quem não tem salário ou outro tipo de rendimento. São os chamados impostos indiretos, que estão embutidos em tudo o que você consome.</p>
      </div>
    </div>

    <button class="cta-scrollbutton" href="#">
      Mas qual é sua faixa de renda e quanto você paga de impostos?

      <span class="cta-scrollbutton-icon">
        <svg>
          <use xlink:href="#icon-arrow-down"></use>
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import gsap from 'gsap';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      animateTotalStudents: 0,
      animateTotalHealth: 0,
      animateTotalPavimentation: 0,
      animateTotalLightning: 0,
      animateTotalTrash: 0,
    };
  },
  mounted() {
    let animateTotalStudents = {
      val: 0
    } 

    let animateTotalHealth = {
      val: 0
    } 

    let animateTotalPavimentation = {
      val: 0
    }

    let animateTotalLightning = {
      val: 0
    }

    let animateTotalTrash = {
      val: 0
    }

    TweenLite
      .to(animateTotalStudents, 3, {
        val: this.totalStudents,
        roundProps: 'val',
        onUpdate: () => {
          this.animateTotalStudents = animateTotalStudents.val;
        }
      });

    TweenLite
      .to(animateTotalHealth, 3, {
        val: this.totalHealth,
        roundProps: 'val',
        onUpdate: () => {
          this.animateTotalHealth = animateTotalHealth.val;
        }
      });

    TweenLite
      .to(animateTotalPavimentation, 3, {
        val: this.totalPavimentation,
        roundProps: 'val',
        onUpdate: () => {
          this.animateTotalPavimentation = animateTotalPavimentation.val;
        }
      });

    TweenLite
      .to(animateTotalLightning, 3, {
        val: this.totalLighting,
        roundProps: 'val',
        onUpdate: () => {
          this.animateTotalLightning = animateTotalLightning.val;
        }
      });

    TweenLite
      .to(animateTotalTrash, 3, {
        val: this.totalTrash,
        roundProps: 'val',
        onUpdate: () => {
          this.animateTotalTrash = animateTotalTrash.val;
        }
      });
  },
  computed: {
    ...mapState(['income']),
    totalStudents() {
      return this.income.data.total_students;
    },
    totalHealth() {
      return this.income.data.total_health;
    },
    totalPavimentation() {
      return Math.round(this.income.data.total_pavement);
    },
    totalLighting() {
      return this.income.data.total_lighting;
    },
    totalTrash() {
      return this.income.data.total_trash;
    }
  },
};
</script>

<style lang="scss">
.result-header {
  position: relative;
  width: 100%;
  padding: rem-calc(65 0 90);

  background-color: #aabf0f;
}

.result-header-container {
  @media #{$small-up} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: rem-calc(35 30);
  }

  @media #{$medium-up} {
    //grid-template-columns: minmax(auto, rem-calc(340)) minmax(auto, rem-calc(340)) minmax(auto, rem-calc(340));
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto auto auto;
  }

  @media #{$xlarge-up} {
    grid-gap: rem-calc(35 60);
  }
}

.result-header__cell {
  position: relative;
  width: 100%;
  margin-bottom: rem-calc(10);

  color: $white;
  text-align: center;

  @media #{$medium-up} {
    text-align: left;
  }

  &:nth-child(1) {
    @media #{$small-up} {
      grid-column: span 2;
    }

    @media #{$medium-up} {
      grid-column: auto;
    }
  }

  p {
    margin: 0;
    font-size: rem-calc(14);

    @media #{$small-up} {
      font-size: rem-calc(20);
    }
  }
}

.result-header-highlight {
  position: absolute;
  top: 50%;
  left: 50%;

  width: 100%;
  height: 100%;

  object-fit: cover;
  transform: translate(-50%, -50%);
}

.result-header-credit {
  position: absolute;
  top: 100%;
  right: 0;
  display: inline-block;
  padding-top: rem-calc(10);
}

.result-header__cell--expand {
  grid-column: span 2;
  height: rem-calc(250);

  margin-top: rem-calc(30);
  margin-bottom: rem-calc(40);

  @media #{$small-up} {
    margin-top: 0;
  }

  @media #{$medium-up} {
    margin-bottom: 0;
    height: auto;
    grid-column: 2 / span 2;
  }
}

.result-header-main-title {
  margin-bottom: rem-calc(20);
  color: $white;
  font-size: rem-calc(34);
  font-family: $font-family--header;
  line-height: rem-calc(42);
}

.result-header-main-subtitle {
  margin: 0 auto;
  max-width: rem-calc(360);

  color: $white;
  font-size: rem-calc(15);
  line-height: rem-calc(24);
  font-weight: 600;

  @media #{$medium-up} {
    margin: 0;
  }

  span {
    &:nth-child(1) {
      position: relative;
      white-space: nowrap;

      &:before {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;

        width: rem-calc(55);
        height: rem-calc(3);

        border-radius: rem-calc(5);
        background-color: #e43989;
        transform: translate(-1px, 6px) rotate(-4deg);
      }
    }
  }
}

.result-header-title {
  color: $white;
  font-size: rem-calc(52);
  font-weight: normal;
  font-family: $font-family--header;

  @media #{$large-up} {
    font-size: rem-calc(96);
  }

  @media #{$xlarge-up} {
    font-size: rem-calc(109);
  }
}

.result-header__cell--tip {
  margin-top: rem-calc(40);
  padding: rem-calc(20 25);
  background-color: #98aa0d;
  border-radius: rem-calc(20);

  @media #{$small-up} {
    grid-column: span 2;
    margin-top: 0;
  }

  @media #{$large-up} {
    grid-column: auto;
  }

  p {
    font-size: rem-calc(16);
  }

  strong {
    display: block;
    margin-bottom: rem-calc(20);

    font-size: rem-calc(20);
    font-weight: normal;
    font-family: $font-family--header;
  }
}

.result-header--icon-lamp {
  position: absolute;
  top: rem-calc(20);
  right: rem-calc(25);

  width: rem-calc(40);
  height: rem-calc(40);
}

.cta-scrollbutton {
  position: absolute;
  bottom: rem-calc(-40);
  left: 50%;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: rem-calc(300);
  height: rem-calc(80);
  padding: rem-calc(0 25);

  color: $minsk;
  font-size: rem-calc(14);

  background-color: $white;
  border-radius: 10px;
  border: none;
  box-shadow: 10px 10px 20px 0 rgba(0, 0, 0, 0.18);

  transform: translateX(-50%);
  outline: 0;

  &.cta-scrollbutton--fixed {
    position: fixed;
    bottom: rem-calc(10);
  }

  @media #{$medium-up} {
    max-width: rem-calc(420);
    font-size: rem-calc(16);
    padding: rem-calc(0 35);
  }
}

.cta-scrollbutton-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;
  width: rem-calc(55);
  height: rem-calc(55);

  background-color: #aabf0f;
  border-radius: 50%;
  
  margin-left: rem-calc(10);

  svg {
    width: rem-calc(11);
    height: rem-calc(21);
  }
}
</style>
